import type { ChatStreamEvent } from '@k4ia/shared'

/**
 * Parses a fetch() Response body as Server-Sent Events and yields typed
 * ChatStreamEvent objects. Browser EventSource can't POST a body, so /api/v1/chat
 * is consumed via fetch + manual SSE framing instead (mirrors packages/core's
 * util/sse.ts on the server side).
 */
export async function* streamChatEvents(
  response: Response,
  signal?: AbortSignal,
): AsyncGenerator<ChatStreamEvent> {
  if (!response.body) throw new Error('Antwort enthält keinen Stream')
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  try {
    while (true) {
      if (signal?.aborted) return
      const { done, value } = await reader.read()
      if (done) break
      buffer += decoder.decode(value, { stream: true })

      let boundary: number
      while ((boundary = buffer.indexOf('\n\n')) !== -1) {
        const rawEvent = buffer.slice(0, boundary)
        buffer = buffer.slice(boundary + 2)
        const dataLine = rawEvent.split('\n').find((l) => l.startsWith('data:'))
        if (!dataLine) continue
        try {
          yield JSON.parse(dataLine.slice(5).trim()) as ChatStreamEvent
        } catch {
          // ignore malformed frame, stream continues
        }
      }
    }
  } finally {
    reader.releaseLock()
  }
}
